var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5C11.7344 10.5 14 8.27344 14 5.5C14 2.76562 11.7344 0.5 9 0.5C6.22656 0.5 4 2.76562 4 5.5C4 8.27344 6.22656 10.5 9 10.5ZM9 1.75C11.0312 1.75 12.75 3.46875 12.75 5.5C12.75 7.57031 11.0312 9.25 9 9.25C6.92969 9.25 5.25 7.57031 5.25 5.5C5.25 3.46875 6.92969 1.75 9 1.75ZM10.9531 12.375H7.00781C3.25781 12.375 0.25 15.4219 0.25 19.1719C0.25 19.9141 0.835938 20.5 1.57812 20.5H16.3828C17.125 20.5 17.75 19.9141 17.75 19.1719C17.75 15.4219 14.7031 12.375 10.9531 12.375ZM16.3828 19.25H1.57812C1.53906 19.25 1.5 19.2109 1.5 19.1719C1.5 16.125 3.96094 13.625 7.00781 13.625H10.9531C14 13.625 16.5 16.125 16.5 19.1719C16.5 19.2109 16.4219 19.25 16.3828 19.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.a40cbd0abf78e9b3c7ada5efdcb72f41.svg";
export { ForwardRef as ReactComponent };